import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC5rHBWCeR8eldXBdiyJEmIsl3TtCTXBHc",
  authDomain: "activiter-commercial.firebaseapp.com",
  projectId: "activiter-commercial",
  storageBucket: "activiter-commercial.firebasestorage.app",
  messagingSenderId: "302399935658",
  appId: "1:302399935658:web:02886750294c365e5cacd3",
  measurementId: "G-E2JK50DEXT"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export default app;
